<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->
          <b-col cols="12" lg="8">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model.trim="searchQuery"
                    @keyup.enter="onSearch()"

                    autocomplete="search"
                    class="d-inline-block round"
                    :placeholder="$t('textPlaceholderSearchUserList')"
                  />
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="4"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-lg-start
                  p-0
                  my-1
                  m-lg-0
                "
              >
                <b-button
                  class="round px-5"
                  variant="primary"
                  :disabled="searchQuery ? false : true"
                  @click="onSearch"
                >
                  {{ $t("search") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            cols="12"
            lg="4"
            class="
              d-flex
              align-items-center
              justify-content-end justify-content-xs-start
              mb-md-0
            "
            v-if="userData.role !== 'ADMIN'"
          >
            <b-button variant="primary" class="round" @click="New()">
              {{ $t("addNewUser") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table
        responsive="sm"
        :items="items"
        :fields="fields"
    
      >
        <template #cell(user_id)="row">
          <span :class="row.item.user_id ? '' : 'status-witing'">{{
            row.item.user_id ? row.item.user_id : "Approving"
          }}</span>
        </template>
        <template #cell(gender_id)="row">
          {{ row.item.gender_id == 1 ? "Male" : "Female" }}
        </template>
        <template #cell(actions)="row">
          <b-button
            v-b-tooltip.hover.top="'Edit user information'"
            v-if="buttomDisabled(row.item.accept_edit)"
            variant="primary"
            size="sm"
            @click="Edit(row.item)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="'Delete!'"
            v-if="userData.role !== 'ADMIN_SALE'"
            variant="danger"
            size="sm"
            @click="Delete(row.item, row.index, $event.target)"
          >
            <feather-icon icon="DeleteIcon" />
          </b-button>
        </template>
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-edit"
      size="lg"
      no-close-on-backdrop
      :title="modal_title"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col cols="6">
            <validation-provider
              :name="$t('contactName')"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("contactName") }}<span class="required">*</span>
                </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="fullName"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label>{{ $t("gender") }}<span class="required">*</span> </label>
              <b-row class="pw-1">
                <b-col cols="4">
                  <b-form-radio v-model="gender" name="some-radios" value="1">
                    {{ $t("Male") }}
                  </b-form-radio>
                </b-col>
                <b-col cols="4">
                  <b-form-radio v-model="gender" name="some-radios" value="2">
                    {{ $t("Female") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <validation-provider
              :name="$t('email')"
              #default="{ errors }"
              rules="required|email"
            >
              <b-form-group>
                <label>{{ $t("email") }}<span class="required">*</span> </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="contactEmail"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider
              :name="$t('phone')"
              #default="{ errors }"
              rules="required|regex:^([0-9]+)$"
            >
              <b-form-group>
                <label>{{ $t("phone") }}<span class="required">*</span> </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="mobile"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <validation-provider
              :name="$t('companyName')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group>
                <label
                  >{{ $t("companyName") }}<span class="required">*</span>
                </label>

                <!-- <multiselect
                  v-model="company"
                  :options="companyItems"
                  :disabled="isDisabledCompany"
                  :class="{ 'has-error': errors[0] }"
                  :state="errors.length > 0 ? false : null"
                  :searchable="true"
                  :show-labels="false"
                  label="text"
                  track-by="text"
                >
                </multiselect> -->
                   <Select4
                  v-model="company"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Company"
                  :options="{
                    isSearch:true,
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: companyItems,
                    fields: [
                      { field: 'code', label: 'Tax Code' },

                      { field: 'name', label: 'Name' },
                      {
                        field: 'acronym',
                        label: 'Acronym',
                      },
                    ],
                  }"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider
              :name="$t('salesman')"
              #default="{ errors }"
              :rules="
                !isDisabledSaler ? { required: 'required', vselect: true } : ''
              "
            >
              <b-form-group>
                <label
                  >{{ $t("salesman") }}<span class="required">*</span>
                </label>

                <multiselect
                  v-model="saler"
                  :options="salerItems"
                  :disabled="isDisabledSaler"
                  :class="{ 'has-error': errors[0] }"
                  :state="errors.length > 0 ? false : null"
                  :searchable="true"
                  :show-labels="false"
                  label="text"
                  track-by="text"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <div v-if="modal_title == $t('updateUserInformation')">
          <b-row>
            <b-col cols="6">
              <validation-provider
                :name="$t('userName')"
                #default="{ errors }"
                :rules="!isDisabledSaler ? 'required' : ''"
              >
                <b-form-group>
                  <label
                    >{{ $t("userName") }}<span class="required">*</span>
                  </label>

                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="isDisabledSaler"
                    v-model="userId"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                :name="$t('passport')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ $t("passport") }}<span class="required">*</span>
                  </label>

                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="passport"
                    placeholder="Enter Identity card/Passport"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <validation-provider
                :name="$t('bankAccount')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ $t("bankAccount") }}<span class="required">*</span>
                  </label>

                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="bankAccount"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                :name="$t('bankName')"
                #default="{ errors }"
                :rules="{ required: 'required', vselect: true }"
              >
                <b-form-group>
                  <label
                    >{{ $t("bankName") }}<span class="required">*</span>
                  </label>

                  <multiselect
                    v-model="bankName"
                    :options="banks"
                    :class="{ 'has-error': errors[0] }"
                    :state="errors.length > 0 ? false : null"
                    :searchable="true"
                    :show-labels="false"
                    :placeholder="$t('enterSelect')"
                    label="text"
                    track-by="text"
                  >
                  </multiselect>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group :label="$t('registrationsDate')">
                <b-form-input disabled v-model="registrationsDate" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group :label="$t('approvedDate')">
                <b-form-input disabled v-model="approvedDate" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOk"
          class="btn round"
        >
          {{
            modal_title == $t("updateUserInformation")
              ? $t("update")
              : $t("add")
          }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BInputGroupAppend,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import router from "@/router";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    idUser: {
      type: String,
      default: "",
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  created() {
    this.fetchUser();
    this.fetchCompany();
    this.fetchSaler();
    this.inputDisabled();
    this.fetchBank();
  },
  computed: {
    ...mapState("masterData", ["banks"]),
  },
  mounted() {
    if (["CLIENT_ROOT"].includes(this.userData.role)) {
      this.fields.push({
        key: "actions",
        label: this.$i18n.t("actions"),
        thClass: "text-center",
        tdClass: "actions-td",
      });
    }
    useJwt
      .get("masterData", { params: { data: "member_types" } })
      .then((response) => {
        this.member_types = response.data.result;
      });
  },
  watch: {
    perPage: function (n, o) {
      this.fetchUser();
    },
    searchQuery: function (n, o) {
      if (this.searchQuery == "") {
        this.fetchUser();
      }
    },
    currentPage: function (n, o) {
      this.fetchUser();
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [

        
    
          {
            key: "user_id",
            sortable: false,
            label: this.$i18n.t("username"),
          },
          {
            key: "full_name",
            sortable: false,
            label: this.$i18n.t("contactName"),
          },
          {
            key: "gender_id",
            label: this.$i18n.t("gender"),
            sortable: false,
          },
          {
            key: "phone",
            label: this.$i18n.t("phone"),
            sortable: false,
          },
          {
            key: "email",
            label: this.$i18n.t("email"),

            sortable: false,
          },
          {
            key: "creator",
            sortable: false,
            label: this.$i18n.t("creator"),
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  methods: {
    ...mapActions("masterData", ["fetchBank"]),
    onSearch() {
      if (this.searchQuery) {
        this.$loading.show();
        this.fetchUser();
      }
    },
    fetchCompany: function () {
      this.companyItems = [];
      useJwt.get("masterData?data=Company", {}).then((response) => {
        const dataCompany = response.data.result;
        const mapCompany = dataCompany.map((obj) => {
          obj.text = obj.acronym + " - " + obj.text || obj.name;
          obj.id = obj.code;
          return obj;
        });
        this.companyItems = mapCompany;
      });
    },
    fetchSaler: function () {
      this.salerItems = [];
      useJwt.get("masterData?data=Saler", {}).then((response) => {
        const dataSaler = response.data.result;
        const mapSaler = dataSaler.map((obj) => {
          obj.text = obj.text || obj.name;
          obj.id = obj.code;
          return obj;
        });
        this.salerItems = mapSaler;
      });
    },
    fetchUser: function () {
      useJwt
        .get("userList", {
          params: {
            search: this.searchQuery.trim(),
            page: this.currentPage,
            pageSize: this.perPage,
            userId: this.idUser,
          },
        })
        .then((response) => {
          this.items = response.data.result;

          this.totalRows = response.data.meta.total;
        })
        .finally(() => this.$loading.hide());
    },
    Edit(item) {
      this.resetData();
      this.fullName = item.full_name;
      this.contactEmail = item.email;
      this.mobile = item.phone;
      this.recordId = item.id;
      this.userId = item.user_id;
      this.passport = item.id_card;
      this.taxCode = this.companyItems.find((e) => e.code == item.org_tax_code);
      this.bankAccount = item.bank_account;
      this.approvedDate = item.approved_date;
      this.registrationsDate = item.created_date;
      this.bankName = this.banks.find((e) => e.name == item.bank_name);
      this.recordId = item.id;
      this.gender = item.gender_id;
      this.company = this.companyItems.find((e) => e.code == item.org_tax_code);
      this.saler = this.salerItems.find((e) => e.id == item.user_sale_id);
      this.modal_title = this.$i18n.t("updateUserInformation");
      this.$bvModal.show("modal-edit");
    },
    New() {
      this.modal_title = this.$i18n.t("addNewUser");
      this.$bvModal.show("modal-edit");
      this.resetData();
      this.company = this.companyItems.find(
        (e) => e.name == this.userData.companyName
      );

      this.saler =
        this.salerItems.find((e) => e.name == this.userData.sale) ||
        this.salerItems.find((e) => e.name == this.userData.fullName);
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDelete") + "?",
        {
          title: this.$i18n.t("deleteUser"),
          size: "sm",
          okTitle: this.$i18n.t("ok"),
          cancelTitle: this.$i18n.t("cancel"),
        }
      );
      if (res) {
        useJwt
          .delete(`userList`, { params: { id: item.id } })
          .then((response) => {
            this.fetchUser();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyDeleted"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("notifyFormError"),
            icon: "XIcon",
            variant: "danger",
          },
        });
        return;
      }
      if (this.modal_title == this.$i18n.t("updateUserInformation")) {
        const data = {
          registerInfo: JSON.stringify({
            email: this.contactEmail.trim().toLowerCase(),
            phone: this.mobile.trim(),
            fullName: this.fullName.trim(),
            genderId: this.gender,
            userSaleId: this.saler.code.trim(),
            taxCode: this.company.code.trim(),
            bankAccount: this.bankAccount.trim(),
            bankCode: this.bankName.code.trim(),
            idCard: this.passport.trim(),
          }),
          id: this.recordId,
          email: this.contactEmail.trim().toLowerCase(),
          phone: this.mobile.trim(),
          fullName: this.fullName.trim(),
          genderId: this.gender,
          userSaleId: this.saler.code.trim(),
          taxCode: this.company.code.trim(),
          bankAccount: this.bankAccount.trim(),
          bankCode: this.bankName.code.trim(),
          idCard: this.passport.trim(),
        };

        useJwt
          .put(`userList`, data)
          .then((response) => {
            this.fetchUser();
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyUpdated"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      } else {
        const data = {
          registerInfo: JSON.stringify({
            email: this.contactEmail.trim().toLowerCase(),
            phone: this.mobile.trim(),
            fullName: this.fullName.trim(),
            genderId: this.gender,
            userSaleId: this.saler.code.trim(),
            taxCode: this.company.code.trim(),
            companyAddress: this.company.address.trim(),
            companyName: this.company.name.trim(),
          }),
          email: this.contactEmail.trim().toLowerCase(),
          phone: this.mobile.trim(),
          fullName: this.fullName.trim(),
          genderId: this.gender,
          userSaleId: this.saler.code.trim(),
          taxCode: this.company.code.trim(),
          companyAddress: this.company.address.trim(),
          companyName: this.company.name.trim(),
        };
        useJwt
          .post("userList", data)
          .then((response) => {
            if (
              response.data.result == "emailExists" ||
              response.data.result == "0"
            ) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  text: this.$i18n.t("emailExist"),
                  icon: "XIcon",
                  variant: "danger",
                },
              });
            } else {
              this.fetchUser();
              this.$bvModal.hide("modal-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("success"),
                  text: this.$i18n.t("successfullyAdded"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    resetData() {
      this.fullName = "";
      this.contactEmail = "";
      this.mobile = "";
      this.gender = 1;
      this.company = {};
      this.saler = {};
      this.recordId = "";
      this.bankAccount = "";
      this.taxCode = "";
      this.userId = "";
      this.approvedDate = "";
      this.registrationsDate = "";
      this.passport = "";
      this.bankName = "";
    },
    buttomDisabled(item) {
      var isDisabled = true;
      switch (this.userData.role) {
        case "CLIENT_ROOT":
          if (item == 0) {
            isDisabled = false;
          }
          break;
        case "ADMIN_SALE":
          isDisabled = false;

          break;
        default:
          isDisabled = false;
          break;
      }
      return isDisabled;
    },
    inputDisabled() {
      switch (this.userData.role) {
        case "CLIENT_ROOT":
          this.isDisabledCompany = true;
          this.isDisabledSaler = true;

          break;
        case "ADMIN_SALE":
          this.isDisabledSaler = true;

          break;
      }
    },
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      gender: 1,
      company: {},
      saler: {},
      mobile: "",
      contactEmail: "",
      fullName: "",
      recordId: "",
      bankAccount: "",
      taxCode: "",
      userId: "",
      approvedDate: "",
      passport: "",
      bankName: "",
      registrationsDate: "",
      items: [],
      companyItems: [],
      salerItems: [],

      isDisabledCompany: false,

      isDisabledSaler: false,

      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      searchQuery: "",

      modal_title: this.$i18n.t("addNewUser"),

      fields: [
          
      {
          key: "user_id",
          sortable: false,
          label: this.$i18n.t("username"),
        },
     
        {
          key: "full_name",
          sortable: false,
          label: this.$i18n.t("contactName"),
        },
        {
          key: "gender_id",
          label: this.$i18n.t("gender"),
          sortable: false,
        },
        {
          key: "phone",
          label: this.$i18n.t("phone"),
          sortable: false,
        },
        {
          key: "email",
          label: this.$i18n.t("email"),

          sortable: false,
        },
        {
            key: "creator",
            sortable: false,
            label: this.$i18n.t("creator"),
          },
       
      ],
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@media (max-width: 865px) {
  .table-responsive-sm {
    overflow: hidden;
    overflow-x: scroll;
  }
  .card {
    overflow: hidden;
  }
}
.status-witing {
  background: rgba(254, 224, 0, 0.33);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-radius: 50rem;
  font-weight: 600;
  color: #fab318;
}
</style>